<section class="container">
  <div class="card shadow-sm">
    <div class="card-header">
      <h3 class="card-title font-weight-semibold">
        <a href="/rota-volta" class="text-dark mr-2">
          <i class="fa fa-arrow-left"></i>
        </a>
        <span>Relatório de Verbas</span>
      </h3>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12 form-group">
          <label>Competência *</label>
          <div class="input-group">
            <select class="form-control shadow-sm" [(ngModel)]="selectedCompetencia">
              <option value="">Selecione...</option>
              <option *ngFor="let c of competencias" [value]="c.VALOR">
                {{ c.DESCRICAO }}
              </option>
            </select>

            <div class="input-group-append">
              <button class="btn btn-primary" (click)="listar()" [disabled]="loadingList">
                {{ loadingList ? 'Carregando...' : 'Listar' }}
                <i class="fa fa-search ml-1"></i>
              </button>
            </div>
          </div>

          <div *ngIf="errorMessage" class="text-danger mt-2">
            {{ errorMessage }}
          </div>
        </div>

        <div class="col-12" *ngIf="loadingList">
          <div class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
            <p class="mt-2 text-muted">Carregando dados...</p>
          </div>
        </div>

        <div class="col-12" *ngIf="!loadingList && (proventos.length > 0 || descontos.length > 0)">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th colspan="4" class="text-primary text-center">Proventos</th>
                  <th colspan="4" class="text-danger text-center">Descontos</th>
                </tr>

                <tr class="table-primary text-center">
                  <th>Tipo Folha</th>
                  <th>Rubrica</th>
                  <th>Valor (R$)</th>
                  <th></th>
                  <th>Tipo Folha</th>
                  <th>Rubrica</th>
                  <th>Valor (R$)</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <ng-container
                  *ngFor="
                    let i of [].constructor(Math.max(proventos.length, descontos.length));
                    let idx = index
                  "
                >
                  <tr>
                    <td *ngIf="proventos[idx]">{{ proventos[idx].tipoFolha }}</td>
                    <td *ngIf="proventos[idx]">
                      {{ proventos[idx].rubricaCodigo }} - {{ proventos[idx].rubricaDescricao }}
                    </td>
                    <td *ngIf="proventos[idx]">{{ proventos[idx].valor | number : '1.2-2' }}</td>
                    <td *ngIf="proventos[idx]">
                      <button
                        class="btn btn-sm btn-outline-primary"
                        (click)="abrirDetalhe(proventos[idx])"
                      >
                        <i class="fa fa-info-circle"></i>
                      </button>
                    </td>

                    <td *ngIf="descontos[idx]">{{ descontos[idx].tipoFolha }}</td>
                    <td *ngIf="descontos[idx]">
                      {{ descontos[idx].rubricaCodigo }} - {{ descontos[idx].rubricaDescricao }}
                    </td>
                    <td *ngIf="descontos[idx]">{{ descontos[idx].valor | number : '1.2-2' }}</td>
                    <td *ngIf="descontos[idx]">
                      <button
                        class="btn btn-sm btn-outline-danger"
                        (click)="abrirDetalhe(descontos[idx])"
                      >
                        <i class="fa fa-info-circle"></i>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- MODAL -->
<div class="modal fade" id="exampleModal" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span [class]="detalheTipo === 'DESCONTOS' ? 'text-danger' : 'text-primary'">
              {{ detalheTipo }}
            </span>
            - {{ detalheTitulo }}
            <span *ngIf="loadingDetalhe" class="badge badge-info">Carregando...</span>
          </h5>
  
          <button type="button" class="close" data-dismiss="modal" [disabled]="loadingDetalhe">
            <span>&times;</span>
          </button>
        </div>
  
        <div class="modal-body">
          <div *ngIf="!loadingDetalhe">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Matrícula</th>
                    <th>Nome</th>
                    <th>Situação</th>
                    <th>Lotação</th>
                    <th>Vínculo</th>
                    <th>Admissão</th>
                    <th>Cargo</th>
                    <th>Pag/Oco</th>
                    <th>Valor (R$)</th>
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let d of detalhes">
                    <td>{{ d.matricula }}</td>
                    <td>{{ d.nome }}</td>
                    <td>{{ d.situacao?.nome }}</td>
                    <td>{{ d.lotacao }}</td>
                    <td>{{ d.vinculo }}</td>
                    <td>{{ d.admissao }}</td>
                    <td>{{ d.cargo_funcao }}</td>
                    <td>{{ d.pag }}/{{ d.oco }}</td>
                    <td>{{ d.valor | number : '1.2-2' }}</td>
                  </tr>
                  <tr *ngIf="detalhes.length > 0">
                    <th colspan="7" class="text-right">Totais</th>
                    <th>{{ totalRegistros }}</th>
                    <th>{{ valorTotal | number:'1.2-2' }}</th>
                  </tr>
  
                  <tr *ngIf="detalhes.length === 0">
                    <td colspan="9" class="text-center">Nenhum detalhe encontrado.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
  
          <div *ngIf="loadingDetalhe" class="text-center py-5" style="min-height: 200px">
            <div
              class="spinner-border text-primary"
              style="width: 3rem; height: 3rem"
              role="status"
            >
              <span class="sr-only">Carregando detalhes...</span>
            </div>
            <p class="mt-3 text-muted">Carregando detalhes...</p>
          </div>
        </div>
 
        <div class="modal-footer justify-content-end">

          <div class="botoes-area">
            <button
              class="btn btn-success"
              (click)="baixarCSV()"
              [disabled]="loadingDetalhe || detalhes.length === 0"
            >
              <i class="fa fa-file-csv mr-1"></i>
              Baixar CSV
            </button>
  
            <button
              class="btn btn-outline-secondary ml-2"
              data-dismiss="modal"
              [disabled]="loadingDetalhe"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
